import { Component, inject } from '@angular/core';
import { OpenDialogService } from '@app/core/services/open-dialog.service';
import { ViewSelectors } from '@app/core/states/view/view.selectors';
import { IconNames } from '@app/shared/enums/icon-names';
import { Dealer } from '@core/models/dealer.model';
import { DealerStateSelectors } from '@app/core/states/dealer/dealer-state.selectors';
import { UserSelectors } from '@app/core/states/user/user.selectors';
import { User } from '@app/core/models/user.model';
import { select } from '@ngxs/store';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-floating-feedback-button',
  templateUrl: './floating-feedback-button.component.html',
  styleUrl: './floating-feedback-button.component.scss',
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu],
})
export class FloatingFeedbackButtonComponent {
  private openDialogService = inject(OpenDialogService);

  isMenuOpen = select(ViewSelectors.isMenuOpen);
  dealers = select(DealerStateSelectors.dealers);
  user = select(UserSelectors.getUser);
  activeDealer = select(DealerStateSelectors.activeDealer);

  IconNames = IconNames;

  openFeedbackDialog(data: { dealer: Dealer; user: User }) {
    this.openDialogService.openFeedbackDialog(data.dealer, data.user);
  }

  openErrorDialog(data: { user: User }) {
    this.openDialogService.openErrorDialog(data.user);
  }
}
